import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";

export default function Testimonial() {
  return (
    <section
      id="story"
      className="relative py-28 md:py-36 px-6 md:px-10 bg-[#202A36] text-white overflow-hidden"
      data-testid="testimonial-section"
    >
      {/* Subtle grid */}
      <div
        className="absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            "linear-gradient(to right, #fff 1px, transparent 1px), linear-gradient(to bottom, #fff 1px, transparent 1px)",
          backgroundSize: "64px 64px",
        }}
      />

      <div className="relative max-w-6xl mx-auto">
        <div className="text-[11px] uppercase tracking-[0.28em] text-white/50 font-mono-x mb-8">
          §04 · The Story
        </div>

        <motion.blockquote
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="font-display text-3xl md:text-5xl lg:text-6xl font-medium leading-[1.05] tracking-[-0.025em] max-w-5xl"
        >
          <Quote className="text-white/20 mb-6" size={40} strokeWidth={1.4} />
          <span className="text-white/40">“</span>Financial intelligence
          tools that respect the rigour of the profession —
          <span className="text-white">
            {" "}built by someone who has sat across the audit table.
          </span>
          <span className="text-white/40">”</span>
        </motion.blockquote>

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.3 }}
          className="mt-12 flex items-center gap-4"
        >
          <img
            src="https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&w=200&q=80"
            alt="Founder"
            className="h-12 w-12 rounded-full object-cover ring-2 ring-white/20"
          />
          <div>
            <div className="font-medium">Founder, CA</div>
            <div className="text-white/50 text-sm">
              Practising Chartered Accountant · Audivis
            </div>
          </div>
          <div className="ml-auto hidden md:flex items-center gap-6 text-[11px] uppercase tracking-[0.22em] text-white/50 font-mono-x">
            <span>10y+ audit floor</span>
            <span>·</span>
            <span>Ind AS · IFRS</span>
            <span>·</span>
            <span>SEBI / IBBI</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
